import * as React from 'react';

export const DropArrow = (
  <svg className='drop-arrow' viewBox='0 0 24 24'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <polygon fillOpacity='0.2' fill='#000000' fillRule='nonzero' points='7 10 12 15 17 10' />
      <polygon points='0 0 24 0 24 24 0 24' />
    </g>
  </svg>
);

export const Grid = (
  <svg width='25' height='25' viewBox='0 0 25 25'>
    <path
      fill='#000'
      fillRule='evenodd'
      d='M518,263h7v7h-7v-7Zm9,0h7v7h-7v-7Zm9,0h7v7h-7v-7Zm-18,9h7v7h-7v-7Zm9,0h7v7h-7v-7Zm9,0h7v7h-7v-7Zm-18,9h7v7h-7v-7Zm9,0h7v7h-7v-7Zm9,0h7v7h-7v-7Z'
      transform='translate(-518 -263)'
    />
  </svg>
);

export const List = (
  <svg width='25' height='25' viewBox='0 0 25 19'>
    <path
      fill='#000'
      fillRule='evenodd'
      id='list_icon'
      data-name='list icon'
      className='cls-list'
      d='M630,266h5v5h-5v-5Zm7,0h18v5H637v-5Zm-7,7h5v5h-5v-5Zm7,0h18v5H637v-5Zm-7,7h5v5h-5v-5Zm7,0h18v5H637v-5Z'
      transform='translate(-630 -266)'
    />
  </svg>
);

export const Location = (
  <svg width='25' height='25' viewBox='0 0 25 25'>
    <path
      fill='#000'
      fillRule='evenodd'
      d='M586.5,263a6.643,6.643,0,0,0-5.931,9.331,41.834,41.834,0,0,0,5.657,8.54,0.357,0.357,0,0,0,.548,0,41.8,41.8,0,0,0,5.658-8.54A6.644,6.644,0,0,0,586.5,263Zm0,10.068a3.443,3.443,0,1,1,3.376-3.442A3.414,3.414,0,0,1,586.5,273.068ZM574,285h25v3H574v-3Z'
      transform='translate(-574 -263)'
    />
  </svg>
);

export const RaceLocation = (
  <svg width='16px' height='23px' viewBox='0 0 16 23'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-683.000000, -634.000000)' fill='#B0B3B5' fillRule='nonzero'>
        <g id='Group' transform='translate(535.000000, 634.000000)'>
          <g id='loca' transform='translate(148.000000, 0.000000)'>
            <path
              d='M8,4.23529412 C5.86666667,4.23529412 4.13333333,6.08823529 4.13333333,8.33823529 C4.13333333,10.5882353 5.86666667,12.4411765 8,12.4411765 C10.1333333,12.4411765 11.8666667,10.5882353 11.8666667,8.33823529 C11.8666667,6.08823529 10.1333333,4.23529412 8,4.23529412 Z M8,11.1176471 C6.53333333,11.1176471 5.33333333,9.92647059 5.33333333,8.33823529 C5.33333333,6.88235294 6.53333333,5.55882353 8,5.55882353 C9.46666667,5.55882353 10.6666667,6.75 10.6666667,8.33823529 C10.6666667,9.79411765 9.46666667,11.1176471 8,11.1176471 Z M8,0 C3.6,0 0,3.70588235 0,8.33823529 C0,12.8382353 7.2,21.8382353 7.6,22.2352941 C7.73333333,22.3676471 7.86666667,22.5 8.13333333,22.5 C8.26666667,22.5 8.53333333,22.3676471 8.66666667,22.2352941 C9.33333333,21.1764706 16,12.7058824 16,8.33823529 C16,3.70588235 12.4,0 8,0 Z M8,20.6470588 C6.4,18.6617647 1.33333333,11.6470588 1.33333333,8.33823529 C1.33333333,4.5 4.26666667,1.32352941 8,1.32352941 C11.7333333,1.32352941 14.8,4.5 14.8,8.33823529 C14.8,11.6470588 9.6,18.6617647 8,20.6470588 Z'
              id='Shape'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Logo = (
  <svg viewBox='0 0 135 28'>
    <g fill='#FFFFFF'>
      <path d='M7.729421,0 L32.021887,0 L37.5130885,7.01071601 L36.0605095,15.0298527 L25.8941124,22.9465032 L29.6699346,27.4027361 L20.979857,27.4027361 L16.889337,23.0182984 L9.3857255,23.0182984 L7.729421,27.4027361 L0,27.4027361 L4.39859265,11.6384901 L12.8225573,7.81142396 L11.3699783,14.7974775 L25.7616081,14.7974775 C26.4092231,14.7974775 26.767537,14.3491688 26.919917,13.7731632 C26.9911381,13.5035203 28.7987184,7.1247114 28.7987184,7.1247114 L13.250436,7.1247114 L7.729421,0 Z' />
      <path d='M34.7823945,0 L64.043774,0 L69.7536077,5.12211944 C69.7536077,5.12211944 66.1240924,18.4195712 65.4643311,20.7942923 C64.8040177,23.1690134 62.1644205,27.9507909 58.6171683,27.9507909 L40.3034095,27.9507909 L34.7823945,21.4996387 L35.51945,17.6638037 L43.6861354,12.0106192 L42.531139,20.2780247 L56.7427837,20.2780247 C57.478735,20.2780247 58.2986058,19.9387789 58.5166859,19.1145046 C58.7667878,18.1685621 61.5184617,7.1247114 61.5184617,7.1247114 L39.751308,7.1247114 L34.7823945,0 Z' />
      <polygon points='43.5712853 12.0572039 55.7175183 12.0572039 52.9542503 8.22082084 48.5401988 8.22082084' />
      <path d='M78.6269278,0 C76.1816702,0 72.4179943,1.92422013 71.7024708,4.46938626 C70.9869472,7.01510045 66.7793817,22.0016568 66.7793817,22.0016568 L71.9343534,27.9507909 L103.242925,27.9507909 L97.4585578,20.2780247 L75.0857488,20.2780247 C75.0857488,20.2780247 77.8815908,9.3700916 78.1200986,8.71900258 C78.3586065,8.06791357 78.7875893,7.1247114 80.1308523,7.1247114 L93.8571998,7.1247114 L92.6282218,14.9476445 L100.977101,9.61068762 L101.991311,5.53590075 L96.5641534,0 L78.6269278,0 Z' />
      <path d='M111.795971,0 C108.277428,0 104.895807,2.04259995 104.23991,4.58776608 C103.584014,7.13348027 100.074304,20.2851495 100.074304,20.2851495 L105.450117,27.9507909 L134.7126,27.9507909 L128.886825,20.2780247 L107.659627,20.2780247 C107.659627,20.2780247 110.399707,9.26979758 110.578587,8.61816052 C110.757468,7.9670715 111.192524,7.1247114 112.424263,7.1247114 L126.983179,7.1247114 L125.666417,14.9476445 L133.658086,9.55149771 L134.7126,5.6394831 L128.827198,0 L111.795971,0 Z' />
      <polygon points='125.923875 14.7741037 113.225541 14.7741037 115.917035 18.6104867 120.954962 18.6104867' />
      <path d='M130.842093,16.6836078 L131.117591,16.6836078 C131.438362,16.6836078 131.698402,16.575093 131.698402,16.3114787 C131.698402,16.0791035 131.530563,15.924004 131.163416,15.924004 C131.010484,15.924004 130.903376,15.9393495 130.842093,15.9546951 L130.842093,16.6836078 Z M130.826634,18.1255398 L130.245823,18.1255398 L130.245823,15.5825659 C130.474945,15.5365293 130.796268,15.5052902 131.20924,15.5052902 C131.682943,15.5052902 131.897159,15.5825659 132.081009,15.6910807 C132.218482,15.7995956 132.325589,16.0012797 132.325589,16.2495485 C132.325589,16.5285084 132.111374,16.745538 131.80551,16.8387073 L131.80551,16.8693984 C132.050091,16.9625677 132.188116,17.1489063 132.264306,17.4897963 C132.341048,17.877271 132.386873,18.0323705 132.448156,18.1255398 L131.820969,18.1255398 C131.744227,18.0323705 131.698402,17.7999953 131.622212,17.5051419 C131.576388,17.226182 131.423456,17.1023217 131.102133,17.1023217 L130.826634,17.1023217 L130.826634,18.1255398 Z M129.281854,16.7921227 C129.281854,17.9238557 130.107798,18.8232135 131.239606,18.8232135 C132.341048,18.8232135 133.151533,17.9238557 133.151533,16.8074682 C133.151533,15.6757352 132.341048,14.7610319 131.224147,14.7610319 C130.107798,14.7610319 129.281854,15.6757352 129.281854,16.7921227 L129.281854,16.7921227 Z M133.793627,16.7921227 C133.793627,18.2340547 132.677278,19.3657877 131.224147,19.3657877 C129.787027,19.3657877 128.63976,18.2340547 128.63976,16.7921227 C128.63976,15.3814298 129.787027,14.2496968 131.224147,14.2496968 C132.677278,14.2496968 133.793627,15.3814298 133.793627,16.7921227 L133.793627,16.7921227 Z' />
    </g>
  </svg>
);

export const Close = (
  <svg viewBox='0 0 9 10'>
    <path
      fill='#737a7e'
      transform='matrix(1,0,0,1,-334,-248)'
      d='M339.705 252.998L342.84999999999997 249.85C343.04499999999996 249.654 343.04499999999996 249.337 342.84999999999997 249.142C342.655 248.946 342.33799999999997 248.946 342.143 249.142L338.998 252.29L335.853 249.142C335.657 248.946 335.341 248.946 335.146 249.142C334.95 249.337 334.95 249.654 335.146 249.85L338.291 252.998L335.146 256.146C334.95 256.341 334.95 256.659 335.146 256.85400000000004C335.243 256.95200000000006 335.37100000000004 257.00100000000003 335.499 257.00100000000003C335.627 257.00100000000003 335.755 256.95200000000006 335.853 256.85400000000004L338.998 253.70600000000005L342.143 256.85400000000004C342.23999999999995 256.95200000000006 342.36899999999997 257.00100000000003 342.496 257.00100000000003C342.62399999999997 257.00100000000003 342.75199999999995 256.95200000000006 342.84999999999997 256.85400000000004C343.04499999999996 256.65900000000005 343.04499999999996 256.34100000000007 342.84999999999997 256.146Z '
    />
  </svg>
);

export const CloseDropdown = (
  <svg
    className='close-dropdown'
    xmlns='http://www.w3.org/2000/svg'
    height='24px'
    viewBox='0 0 24 24'
    width='24px'
    fillOpacity='0.2'
    fill='#000000'
  >
    <path d='M0 0h24v24H0V0z' fill='none' />
    <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z' />
  </svg>
);

export const Logout = (
  <svg width='20' height='20' viewBox='0 0 20 20'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M1441,40l-4.54,4.576-1.17-1.186L1438,41h-11V39h11l-2.71-2.39,1.17-1.186Zm-8-8h-10V48h10V45h2v5h-14V30h14v5h-2V32Z'
      transform='translate(-1421 -30)'
    />
  </svg>
);

export const Search = (
  <svg viewBox='0 0 18 18'>
    <path
      fill='#a2abb2'
      fillRule='evenodd'
      d='M2627.78,2263.72l-4.33-4.33a7.489,7.489,0,1,0-1.06,1.07l4.33,4.32A0.75,0.75,0,0,0,2627.78,2263.72Zm-10.19-3.06a6.075,6.075,0,1,1,6.07-6.07A6.075,6.075,0,0,1,2617.59,2260.66Z'
      transform='translate(-2610 -2247)'
    />
  </svg>
);

export const Fb = (
  <svg viewBox='0 0 41 41'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M1178.63,2245.49v-3.33h1.96v-2.01c0-2.71.78-4.66,3.64-4.66h3.41v3.32h-2.4a1.408,1.408,0,0,0-1.47,1.69v1.66h3.69l-0.5,3.33h-3.19v10.02h-3.18v-10.02h-1.96Z'
      transform='translate(-1162.5 -2225.5)'
    />
  </svg>
);

export const Linked = (
  <svg viewBox='0 0 41 41'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M1280.78,2254.44H1277v-13.55h3.78v13.55Zm-1.77-14.38a1.816,1.816,0,1,1,1.77-1.82A1.791,1.791,0,0,1,1279.01,2240.06Zm14.99,14.38h-3.78v-8.38c0-.98-0.27-1.67-1.45-1.67a2.288,2.288,0,0,0-2.33,1.67v8.38h-3.77v-13.55h3.77v1.29a6.257,6.257,0,0,1,3.78-1.29c1.23,0,3.78.75,3.78,5.29v8.26Z'
      transform='translate(-1264.5 -2225.5)'
    />
  </svg>
);

export const Instagram = (
  <svg viewBox='0 0 41 41'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M1408.48,1180h-8.96a5.531,5.531,0,0,1-5.52-5.52v-8.96a5.531,5.531,0,0,1,5.52-5.52h8.96a5.531,5.531,0,0,1,5.52,5.52v8.96A5.531,5.531,0,0,1,1408.48,1180Zm3.75-5.52v-8.96a3.751,3.751,0,0,0-3.75-3.75h-8.96a3.751,3.751,0,0,0-3.75,3.75v8.96a3.751,3.751,0,0,0,3.75,3.75h8.96a3.751,3.751,0,0,0,3.75-3.75h0Zm-2.86-8.54a1.277,1.277,0,0,1-.92-0.38,1.3,1.3,0,0,1-.38-0.92,1.3,1.3,0,1,1,2.6,0,1.3,1.3,0,0,1-.38.92A1.277,1.277,0,0,1,1409.37,1165.94Zm-5.37,9.21a5.15,5.15,0,1,1,5.15-5.15A5.155,5.155,0,0,1,1404,1175.15Zm0-8.53a3.38,3.38,0,1,0,3.38,3.38A3.389,3.389,0,0,0,1404,1166.62Z'
      transform='translate(-1383.5 -1149.5)'
    />
  </svg>
);

export const Tw = (
  <svg viewBox='0 0 41 41'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M1225.23,2251.95a6.4,6.4,0,0,0,.88.06,7.015,7.015,0,0,0,4.59-1.74,3.775,3.775,0,0,1-3.45-2.85,3.1,3.1,0,0,0,.69.08,3.446,3.446,0,0,0,.97-0.14,4.049,4.049,0,0,1-2.96-4.04v-0.05a3.5,3.5,0,0,0,1.67.53,4.259,4.259,0,0,1-1.64-3.42,4.468,4.468,0,0,1,.5-2.05,10.325,10.325,0,0,0,7.62,4.36,4.053,4.053,0,0,1-.1-0.92,3.815,3.815,0,0,1,3.69-4,3.633,3.633,0,0,1,2.7,1.32,6.934,6.934,0,0,0,2.34-.94,3.908,3.908,0,0,1-1.62,2.21,6.908,6.908,0,0,0,2.12-.61,7.735,7.735,0,0,1-1.84,2.06c0,0.17.01,0.35,0.01,0.52,0,5.32-3.72,11.46-10.51,11.46A9.736,9.736,0,0,1,1225.23,2251.95Z'
      transform='translate(-1212.5 -2225.5)'
    />
  </svg>
);

export const Gear = (
  <svg className='gear' width='20px' height='20px' viewBox='0 0 20 20'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-41.000000, -215.000000)'>
        <g transform='translate(15.000000, 213.000000)'>
          <g transform='translate(24.000000, 0.000000)'>
            <polygon points='0 0 24 0 24 24 0 24' />
            <path
              d='M19.43,12.98 C19.47,12.66 19.5,12.34 19.5,12 C19.5,11.66 19.47,11.34 19.43,11.02 L21.54,9.37 C21.73,9.22 21.78,8.95 21.66,8.73 L19.66,5.27 C19.54,5.05 19.27,4.97 19.05,5.05 L16.56,6.05 C16.04,5.65 15.48,5.32 14.87,5.07 L14.49,2.42 C14.46,2.18 14.25,2 14,2 L10,2 C9.75,2 9.54,2.18 9.51,2.42 L9.13,5.07 C8.52,5.32 7.96,5.66 7.44,6.05 L4.95,5.05 C4.72,4.96 4.46,5.05 4.34,5.27 L2.34,8.73 C2.21,8.95 2.27,9.22 2.46,9.37 L4.57,11.02 C4.53,11.34 4.5,11.67 4.5,12 C4.5,12.33 4.53,12.66 4.57,12.98 L2.46,14.63 C2.27,14.78 2.22,15.05 2.34,15.27 L4.34,18.73 C4.46,18.95 4.73,19.03 4.95,18.95 L7.44,17.95 C7.96,18.35 8.52,18.68 9.13,18.93 L9.51,21.58 C9.54,21.82 9.75,22 10,22 L14,22 C14.25,22 14.46,21.82 14.49,21.58 L14.87,18.93 C15.48,18.68 16.04,18.34 16.56,17.95 L19.05,18.95 C19.28,19.04 19.54,18.95 19.66,18.73 L21.66,15.27 C21.78,15.05 21.73,14.78 21.54,14.63 L19.43,12.98 Z M12,15.5 C10.07,15.5 8.5,13.93 8.5,12 C8.5,10.07 10.07,8.5 12,8.5 C13.93,8.5 15.5,10.07 15.5,12 C15.5,13.93 13.93,15.5 12,15.5 Z'
              fillOpacity='0.2'
              fill='#000000'
              fillRule='nonzero'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const WishAdded = (
  <svg width='23' height='20' viewBox='0 0 23 20'>
    <path
      fill='#fbc400'
      fillRule='evenodd'
      d='M2228.14,972.856a6.412,6.412,0,0,0-9,0l-0.63.622-0.64-.631a6.418,6.418,0,0,0-9.01-.01,6.251,6.251,0,0,0,.01,8.908l9.16,9.057a0.663,0.663,0,0,0,.93,0l9.17-9.043A6.257,6.257,0,0,0,2228.14,972.856Z'
      transform='translate(-2207 -971)'
    />
    <path
      fill='#262e35'
      fillRule='evenodd'
      d='M2217.18,981.537l-2.38-2.194-0.8.731,3.18,2.926,6.82-6.269-0.8-.731Z'
      transform='translate(-2207 -971)'
    />
  </svg>
);

export const WishAdd = (
  <svg width='23' height='20' viewBox='0 0 23 20'>
    <path
      fill='#000000'
      fillRule='evenodd'
      d='M2227,981a5.433,5.433,0,0,0,1.68-3.687,4.952,4.952,0,0,0-1.47-3.536,5.1,5.1,0,0,0-7.15,0l-1.09,1.081a0.661,0.661,0,0,1-.93,0l-1.1-1.09a5.1,5.1,0,0,0-7.15,0,4.968,4.968,0,0,0,.01,7.065l8.69,8.6L2220,988h2l-3.04,2.812a0.663,0.663,0,0,1-.93,0l-9.16-9.057a6.251,6.251,0,0,1-.01-8.908,6.418,6.418,0,0,1,9.01.01l0.64,0.631,0.63-.622a6.412,6.412,0,0,1,9,0,6.2,6.2,0,0,1,1.86,4.457,6.918,6.918,0,0,1-2,4.687Zm-2,4h3v-2h-3v-3h-2v3h-3v2h3v3h2v-3Z'
      transform='translate(-2207 -971)'
    />
  </svg>
);

export const Office = (
  <svg x='0px' y='0px' viewBox='0 0 512 512'>
    <path
      d='M486.4,460.8c-1.476,0-2.944,0.128-4.386,0.384c-5.888-10.607-17.092-17.451-29.747-17.451
				c-12.655,0-23.859,6.844-29.747,17.451c-1.442-0.256-2.91-0.384-4.386-0.384c-14.114,0-25.6,11.486-25.6,25.6
				c0,3.004,0.614,5.845,1.579,8.533H358.4v-51.2h42.667c4.71,0,8.533-3.823,8.533-8.533V93.867c0-4.71-3.823-8.533-8.533-8.533
				h-256c-4.71,0-8.533,3.823-8.533,8.533v409.6c0,4.71,3.823,8.533,8.533,8.533H486.4c14.114,0,25.6-11.486,25.6-25.6
				S500.514,460.8,486.4,460.8z M358.4,102.4h34.133v51.2H358.4V102.4z M358.4,170.667h34.133v51.2H358.4V170.667z M358.4,238.933
				h34.133v51.2H358.4V238.933z M358.4,307.2h34.133v51.2H358.4V307.2z M358.4,375.467h34.133v51.2H358.4V375.467z M187.733,494.933
				H153.6v-51.2h34.133V494.933z M187.733,426.667H153.6v-51.2h34.133V426.667z M187.733,358.4H153.6v-51.2h34.133V358.4z
				 M187.733,290.133H153.6v-51.2h34.133V290.133z M187.733,221.867H153.6v-51.2h34.133V221.867z M187.733,153.6H153.6v-51.2h34.133
				V153.6z M238.933,494.933H204.8v-51.2h34.133V494.933z M238.933,426.667H204.8v-51.2h34.133V426.667z M238.933,358.4H204.8v-51.2
				h34.133V358.4z M238.933,290.133H204.8v-51.2h34.133V290.133z M238.933,221.867H204.8v-51.2h34.133V221.867z M238.933,153.6
				H204.8v-51.2h34.133V153.6z M290.133,494.933H256v-51.2h34.133V494.933z M290.133,426.667H256v-51.2h34.133V426.667z
				 M290.133,358.4H256v-51.2h34.133V358.4z M290.133,290.133H256v-51.2h34.133V290.133z M290.133,221.867H256v-51.2h34.133V221.867
				z M290.133,153.6H256v-51.2h34.133V153.6z M341.333,494.933H307.2v-51.2h34.133V494.933z M341.333,426.667H307.2v-51.2h34.133
				V426.667z M341.333,358.4H307.2v-51.2h34.133V358.4z M341.333,290.133H307.2v-51.2h34.133V290.133z M341.333,221.867H307.2v-51.2
				h34.133V221.867z M341.333,153.6H307.2v-51.2h34.133V153.6z M486.4,494.933h-68.267c-4.702,0-8.533-3.831-8.533-8.533
				s3.831-8.533,8.533-8.533c1.638,0,3.191,0.469,4.625,1.391c2.338,1.502,5.257,1.775,7.834,0.734
				c2.577-1.041,4.48-3.277,5.103-5.982c1.801-7.774,8.619-13.21,16.572-13.21c7.953,0,14.771,5.436,16.572,13.21
				c0.623,2.705,2.526,4.941,5.103,5.982c2.577,1.041,5.495,0.768,7.834-0.734c5.547-3.584,13.167,0.802,13.158,7.142
				C494.933,491.102,491.102,494.933,486.4,494.933z'
    />
    <path
      d='M187.733,59.733v-25.6h59.733c4.71,0,8.533-3.823,8.533-8.533v-8.533h34.133V25.6c0,4.71,3.823,8.533,8.533,8.533H358.4
				V51.2H213.333c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533h213.333v353.954c0,4.71,3.823,8.533,8.533,8.533
				s8.533-3.823,8.533-8.533V59.733c0-4.71-3.823-8.533-8.533-8.533h-59.733V25.6c0-4.71-3.823-8.533-8.533-8.533H307.2V8.533
				c0-4.71-3.823-8.533-8.533-8.533h-51.2c-4.71,0-8.533,3.823-8.533,8.533v8.533H179.2c-4.71,0-8.533,3.823-8.533,8.533v25.6
				h-59.733c-4.71,0-8.533,3.823-8.533,8.533v435.2H51.2v-34.995c19.447-3.968,34.133-21.197,34.133-41.805
				c0-1.109-0.486-110.933-42.667-110.933C0.486,307.2,0,417.024,0,418.133c0,20.608,14.686,37.837,34.133,41.805v34.995h-25.6
				c-4.71,0-8.533,3.823-8.533,8.533S3.823,512,8.533,512h102.4c4.71,0,8.533-3.823,8.533-8.533v-435.2H179.2
				C183.91,68.267,187.733,64.444,187.733,59.733z M17.067,418.133c0-42.513,11.418-93.867,25.6-93.867
				c14.182,0,25.6,51.354,25.6,93.867c0,14.114-11.486,25.6-25.6,25.6S17.067,432.247,17.067,418.133z'
    />
  </svg>
);

export const Flag = (
  <svg width='30' height='39' viewBox='0 0 30 39'>
    <path
      d='M531.162 206.437C523.8480000000001 205.90300000000002 519.0450000000001
    213.24 511.73 212.70700000000002C511.153 212.63500000000002 510.623 212.341
     510.41200000000003 211.56500000000003C509.10100000000006 206.73100000000002
      507.81000000000006 201.89000000000001 506.509 197.05300000000003C506.368
       196.52900000000002 506.73900000000003 196.22700000000003 507.31600000000003
        196.29800000000003C514.6310000000001 196.83200000000002 519.4340000000001
         189.49500000000003 526.749 190.02800000000002C527.678 190.085
          527.9250000000001 190.64600000000002 528.066 191.17000000000002C529.3670000000001
           196.007 530.669 200.84500000000003 531.969 205.68200000000002C532.11
            206.20600000000002 531.74 206.50900000000001 531.162 206.437ZM513.409
             197.267C513.768 198.601 514.127 199.936 514.486
              201.26999999999998C512.985 201.868 511.55 202.22099999999998 509.933
               202.26799999999997C510.34 203.78499999999997 510.748 205.30199999999996
                511.156 206.81799999999998C512.774 206.76999999999998 514.2090000000001
                 206.41799999999998 515.71 205.82C515.302 204.304 514.894 202.787 514.486
                  201.26999999999998C515.954 200.60999999999999 517.338 199.819 518.724
                   199.00199999999998C518.365 197.66699999999997 518.0060000000001
                    196.332 517.647 194.998C516.2610000000001 195.815 514.8770000000001
                     196.606 513.409 197.267ZM519.948 203.551C521.334 202.736
                      522.7189999999999 201.956 524.194 201.315C523.7869999999999
                       199.798 523.3789999999999 198.282 522.971 196.765C521.496
                        197.40599999999998 520.11 198.18699999999998 518.724
                         199.00199999999998C519.1320000000001 200.51799999999997
                          519.5400000000001 202.03499999999997 519.9480000000001
                           203.551ZM521.011 207.631C520.646 206.277 520.2819999999999
                            204.923 519.918 203.569C518.542 204.38 517.167 205.164
                             515.71 205.82C516.0740000000001 207.174 516.438 208.528
                              516.803 209.882C518.26 209.227 519.634 208.442 521.011
                               207.631ZM528.53 200.408C527.001 200.458 525.65 200.767
                                524.22 201.30499999999998C524.5840000000001 202.659
                                 524.948 204.01299999999998 525.313 205.367C526.7429999999999
                                  204.82999999999998 528.0939999999999 204.521
                                   529.6229999999999 204.471C529.2589999999999
                                    203.117 528.8939999999999 201.762 528.53
                                     200.40800000000002ZM526.229 191.855C524.691
                                      191.90599999999998 523.3330000000001 192.218 521.894 192.762C522.253 194.096 522.612 195.431 522.971 196.765C524.41 196.22199999999998 525.768 195.909 527.306 195.85799999999998C526.9480000000001 194.52399999999997 526.5880000000001 193.18899999999996 526.229 191.85499999999996ZM513.385 227.467L505.404 196.74800000000002C505.238 196.09000000000003 504.574 195.69100000000003 503.92 195.85800000000003C503.266 196.02500000000003 502.87 196.69400000000005 503.036 197.35300000000004L511.017 228.07100000000003C511.157 228.62900000000002 511.654 229.00000000000003 512.2 229.00000000000003C512.3000000000001 229.00000000000003 512.4000000000001 228.98700000000002 512.5010000000001 228.96200000000002C513.1550000000001 228.79500000000002 513.551 228.126 513.3850000000001 227.467Z '
      fill='#fbc400'
      fillOpacity='1'
      transform='matrix(1,0,0,1,-502,-190)'
    />
  </svg>
);

export const FlagIcon = (
  <svg width='15px' height='17px' viewBox='0 0 15 17'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.5'>
      <g transform='translate(-1153.000000, -300.000000)' fill='#000000'>
        <g transform='translate(235.000000, 300.000000)'>
          <g transform='translate(918.000000, 0.000000)'>
            <path
              d='M9.4,2 L15,2 L15,12 L8,12 L7.6,10 L2,10 L2,17 L0,17 L0,0 L9,0 L9.4,2 Z M9,10 L11,10 L11,8 L13,8 L13,6 L11,6 L11,4 L9,4 L9,6 L8,4 L8,2 L6,2 L6,4 L4,4 L4,2 L2,2 L2,4 L4,4 L4,6 L2,6 L2,8 L4,8 L4,6 L6,6 L6,8 L8,8 L8,6 L9,8 L9,10 Z M6,6 L6,4 L8,4 L8,6 L6,6 Z M9,6 L11,6 L11,8 L9,8 L9,6 Z'
              fillRule='nonzero'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Calendar = (
  <svg width='33' height='30' viewBox='0 0 33 30'>
    <path
      fill='#b0b3b5'
      fillRule='evenodd'
      className='cls-1'
      d='M936,365V336.948h10.224V335h2.33v1.948h7.894V335h2.329v1.948H969V365H936Zm31-26h-8v2h-2v-2h-9v2h-2v-2h-8v4h29v-4Zm0,6H938v18h29V345Zm-20,7h-3v-3h3v3Zm0,7h-3v-3h3v3Zm7-7h-3v-3h3v3Zm0,7h-3v-3h3v3Zm7-7h-3v-3h3v3Zm0,7h-3v-3h3v3Z'
      transform='translate(-936 -335)'
    />
  </svg>
);

export const Check = (
  <svg width='12px' height='9px' viewBox='0 0 12 9'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-666.000000, -420.000000)' fill='#ffffff' fillRule='nonzero'>
        <g id='check-circle' transform='translate(666.000000, 420.000000)'>
          <polygon points='5 8.5 12 1.5 10.59 0.09 5 5.67 1.91 2.59 0.5 4' />
        </g>
      </g>
    </g>
  </svg>
);

export const CheckCircle = (
  <svg width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path
        id='3nsfu7aw7a'
        d='M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z'
      />
    </defs>
    <g fill='none' fill-rule='evenodd' transform='translate(2 2)'>
      <mask id='fgst20ff5b' fill='#fff'>
        <use xlinkHref='#3nsfu7aw7a' />
      </mask>
      <g fill='#66BB6A' mask='url(#fgst20ff5b)'>
        <path d='M0 0H24V24H0z' transform='translate(-2 -2)' />
      </g>
    </g>
  </svg>
);

export const CheckYellow = (
  <svg width='22px' height='22px' viewBox='0 0 12 9'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-666.000000, -420.000000)' fill='#f9d026' fillRule='nonzero'>
        <g id='check-circle' transform='translate(666.000000, 420.000000)'>
          <polygon points='5 8.5 12 1.5 10.59 0.09 5 5.67 1.91 2.59 0.5 4' />
        </g>
      </g>
    </g>
  </svg>
);

export const ExclamationMark = (
  <svg width='2px' height='10px' viewBox='0 0 2 10'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-639.000000, -413.000000)' fill='#ffffff' fillRule='nonzero'>
        <g transform='translate(639.000000, 413.000000)'>
          <path d='M2,6 L0,6 L0,0 L2,0 L2,6 Z M2,10 L0,10 L0,8 L2,8 L2,10 Z' />
        </g>
      </g>
    </g>
  </svg>
);

export const Female = (
  <svg width='9' height='20' id='female-img' className='img-svg svg svg'>
    <path
      fillRule='evenodd'
      d='M4.5 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 4.5 0M3 20v-6H0l2.59-7.59C2.84 5.59 3.6 5 4.5 5c.9 0 1.66.59 1.91 1.41L9 14H6v6H3z'
      opacity='.302'
    />
  </svg>
);

export const Male = (
  <svg width='7' height='20' id='male-img' className='img-svg svg svg'>
    <path
      fillRule='evenodd'
      d='M3.5 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 3.5 0M2 5h3a2 2 0 0 1 2 2v5.5H5.5V20h-4v-7.5H0V7a2 2 0 0 1 2-2z'
      opacity='.302'
    />
  </svg>
);

export const ArrowLeft = (
  <svg width='10px' height='5px' viewBox='0 0 10 5'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-22.000000, -223.000000)'>
        <g transform='translate(15.000000, 213.000000)'>
          <g transform='translate(12.000000, 12.000000) rotate(360.000000) translate(-12.000000, -12.000000) '>
            <polygon id='Shape' fillOpacity='0.2' fill='#000000' fillRule='nonzero' points='7 10 12 15 17 10' />
            <polygon id='Shape' points='0 0 24 0 24 24 0 24' />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const TrophyIcon = (
  <svg width='20px' height='20px'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='1'>
      <g fill='#fff' fillRule='nonzero'>
        <path d='M5,0 L5,2 L0,2 L0,9 C0,10 1,11 2,11 L5.2,11 C5.6,12.9 6.6,14.6 9,14.9 L9,17 C6,17.2 6,18.3 6,19.6 L6,20 L14,20 L14,19.7 C14,18.4 14,17.3 11,17.1 L11,15 C13.5,14.7 14.5,13 14.8,11.1 L18,11.1 C19,11.1 20,10.1 20,9.1 L20,2 L15,2 L15,0 L5,0 Z M7,2 L13,2 L13,10 C13,11.6568542 11.6568542,13 10,13 C8,13 7,11.66 7,10 L7,2 Z M2,4 L5,4 L5,6 L5,9 L2,9 L2,4 Z M15,4 L18,4 L18,9 L15,9 L15,4 Z' />
      </g>
    </g>
  </svg>
);

export const UserIcon = (
  <svg width='16px' height='16px' viewBox='0 0 16 16'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.200000003'>
      <g transform='translate(-93.000000, -12.000000)' fill='#000000' fillRule='nonzero'>
        <g transform='translate(93.000000, 12.000000)'>
          <path d='M8,9 C5.33,9 0,10.33 0,13 L0,16 L16,16 L16,13 C16,10.33 10.67,9 8,9 Z M8,0 C5.790861,0 4,1.790861 4,4 C4,6.209139 5.790861,8 8,8 C10.209139,8 12,6.209139 12,4 C12,1.790861 10.209139,0 8,0 Z M8,10.9 C10.97,10.9 14.1,12.36 14.1,13 L14.1,14.1 L1.9,14.1 L1.9,13 C1.9,12.36 5,10.9 8,10.9 Z M8,1.9 C9.15979797,1.9 10.1,2.84020203 10.1,4 C10.1,5.15979797 9.15979797,6.1 8,6.1 C6.84020203,6.1 5.9,5.15979797 5.9,4 C5.9,2.84020203 6.84020203,1.9 8,1.9 Z' />
        </g>
      </g>
    </g>
  </svg>
);

export const TshirtIcon = (
  <svg width='22px' height='18px' viewBox='0 0 22 18'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='1'>
      <g fill='#fff' fillRule='nonzero'>
        <path d='M15,18 L7,18 C6.44771525,18 6,17.5522847 6,17 L6,9.07 L4.7,10.12 C4.31,10.5 3.68,10.5 3.29,10.12 L0.46,7.29 C0.07,6.9 0.07,6.27 0.46,5.88 L6.34,0 L8,0 C8,1.1 9.34,2 11,2 C12.66,2 14,1.1 14,0 L15.66,0 L21.54,5.88 C21.93,6.27 21.93,6.9 21.54,7.29 L18.71,10.12 C18.32,10.5 17.69,10.5 17.3,10.12 L16,9.07 L16,17 C16,17.5522847 15.5522847,18 15,18 Z M19.42,6.58 L15.11,2.28 C14.8,2.63 14.43,2.94 14,3.2 C13.16,3.7 12.13,4 11,4 C9.3,4 7.79,3.32 6.89,2.28 L2.58,6.58 L4,8 L7,6 L8,6 L8,16 L14,16 L14,6 L15,6 L18,8 L19.42,6.58 Z' />
      </g>
    </g>
  </svg>
);

export const TooltipIcon = (
  <svg width='20px' height='20px' viewBox='0 0 20 20'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' fillOpacity='0.4'>
      <path
        fill='#000000'
        fillRule='nonzero'
        d='M9,16 L11,16 L11,14 L9,14 L9,16 Z M10,0 C4.4771525,-2.22044605e-15 0,4.4771525 -4.4408921e-16,10 C-1.77635684e-15,12.6521649 1.0535684,15.195704 2.92893219,17.0710678 C4.80429597,18.9464316 7.3478351,20 10,20 C12.6521649,20 15.195704,18.9464316 17.0710678,17.0710678 C18.9464316,15.195704 20,12.6521649 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,-2.22044605e-16 10,-4.4408921e-16 Z M10,18 C5.59,18 2,14.41 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,14.41 14.41,18 10,18 Z M10,4 C7.790861,4 6,5.790861 6,8 L8,8 C8,6.8954305 8.8954305,6 10,6 C11.1045695,6 12,6.8954305 12,8 C12,10 9,9.75 9,13 L11,13 C11,10.75 14,10.5 14,8 C14,5.790861 12.209139,4 10,4 Z'
      />
    </g>
  </svg>
);

export const CloseIcon = (
  <svg className='drop-arrow' width='14px' height='14px' viewBox='0 0 14 14'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-274.000000, -125.000000)'>
        <g transform='translate(269.000000, 120.000000)'>
          <polygon
            className='svg-fill'
            fillOpacity='0.38'
            fill='#000000'
            fillRule='nonzero'
            points='19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12'
          />
          <polygon points='0 0 24 0 24 24 0 24' />
        </g>
      </g>
    </g>
  </svg>
);

export const WhiteCloseIcon = (
  <svg className='drop-arrow' width='15px' height='15px' viewBox='0 0 14 14'>
    <g strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-274.000000, -125.000000)'>
        <g transform='translate(269.000000, 120.000000)'>
          <polygon
            fill='#fff'
            points='19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12'
          />
          <polygon points='0 0 24 0 24 24 0 24' />
        </g>
      </g>
    </g>
  </svg>
);

export const ExpandIcon = (
  <svg width='12px' height='8px' viewBox='0 0 12 8'>
    <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(-6.000000, -9.000000)'>
      <polygon fill='#000000' fill-rule='nonzero' opacity='0.2' points='7.41 9 12 13.3968 16.59 9 18 10.3536 12 16.1136 6 10.3536' />
      <polygon points='0 0 24 0 24 24 0 24' />
    </g>
  </svg>
);

export const ExpandPlusIcon = (
  <svg width='20px' height='20px' viewBox='0 0 20 20'>
    <g className='open-expand' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g transform='translate(-932.000000, -10.000000)'>
        <g transform='translate(930.000000, 8.000000)'>
          <polygon id='Shape' points='0 0 24 0 24 24 0 24' />
          <path
            d='M13,7 L11,7 L11,11 L7,11 L7,13 L11,13 L11,17 L13,17 L13,13 L17,13 L17,11 L13,11 L13,7 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z'
            fill-opacity='0.2'
            fill='#000000'
            fill-rule='nonzero'
          />
        </g>
      </g>
    </g>
    <g className='close-expand' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g transform='translate(-2.000000, -2.000000)'>
        <polygon id='Shape' points='0 0 24 0 24 24 0 24' />
        <path
          d='M7,11 L7,13 L17,13 L17,11 L7,11 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z'
          fill='#EF9A9A'
          fill-rule='nonzero'
        />
      </g>
    </g>
  </svg>
);

export const Arrow = (
  <svg width='12' height='8' viewBox='0 0 12 8'>
    <g fill='none' fillRule='evenodd'>
      <path fill='#000' fillRule='nonzero' d='M1.41 0L6 4.397 10.59 0 12 1.354l-6 5.76-6-5.76z' opacity='.2' />
      <path d='M-6-9h24v24H-6z' />
    </g>
  </svg>
);

export const CollapseRace = (
  <svg width='26' height='26' viewBox='0 0 26 26'>
    <defs>
      <path id='a' d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' />
    </defs>
    <g fill='none' fillRule='evenodd' transform='matrix(1 0 0 -1 1 25)'>
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <g fill='#FBC400' mask='url(#b)'>
        <path d='M0 0h24v24H0z' />
      </g>
      <circle cx='12' cy='12' r='12' stroke='#FBC400' />
    </g>
  </svg>
);

export const LeaderIcon = (
  <svg width='16' height='16' viewBox='0 0 16 16'>
    <g fill='none' fillRule='evenodd'>
      <circle cx='8' cy='8' r='8' fill='#FBC400' />
      <path
        fill='#FFF'
        fillRule='nonzero'
        d='M4.111 10.111L3 4l3.056 3.889L8 4l1.944 3.889L13 4l-1.111 6.111H4.11zm7.778 1.667a.556.556 0 0 1-.556.555H4.667a.556.556 0 0 1-.556-.555v-.556h7.778v.556z'
      />
    </g>
  </svg>
);

export const IconArrowRight = (
  <svg width='8px' height='12px' viewBox='0 0 8 12' version='1.1'>
    <defs>
      <polygon id='path-1' points='10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12' />
    </defs>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='team-management' transform='translate(-689.000000, -408.000000)'>
        <g id='ic/chevron_right' transform='translate(681.000000, 402.000000)'>
          <g id='ic_chevron_right_24px'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1' />
            </mask>
            <g id='Path' fillRule='nonzero' />
            <g id='c/grey/600' mask='url(#mask-2)' fill='#FBC400'>
              <rect id='Shape' x='0' y='0' width='24' height='24' />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EditPencil = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path
        id='a'
        d='M0 15.25V19h3.75L14.81 7.94l-3.75-3.75L0 15.25zM17.71 5.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
      />
    </defs>
    <g fill='none' fill-rule='evenodd' transform='translate(3 2)'>
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <g fill='#FBC400' mask='url(#b)'>
        <path d='M-3-2h24v24H-3z' />
      </g>
    </g>
  </svg>
);

export const EditUserIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#000'
        fillOpacity='.2'
        fillRule='nonzero'
        d='M20.7 13.35l-1 1-2.05-2.05 1-1a.55.55 0 0 1 .77 0l1.28 1.28c.21.21.21.56 0 .77zM11 18.94l6.06-6.06 2.05 2.05L13.06 21H11v-2.06zM11 14c-4.42 0-8 1.79-8 4v2h6v-1.89l4-4c-.66-.08-1.33-.11-2-.11zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8z'
      />
      <path d='M0 0h24v24H0z' />
    </g>
  </svg>
);

export const AddMemberIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='16' viewBox='0 0 22 16'>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#FBC400'
        fillRule='nonzero'
        d='M14 10c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4zM5 6V3H3v3H0v2h3v3h2V8h3V6H5zm9 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'
      />
      <path d='M-1-4h24v24H-1z' />
    </g>
  </svg>
);

export const ResendInvitationIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#000'
        fillOpacity='.2'
        d='M14.11 8.625a4.412 4.412 0 0 0-2.012 3.14H.588A.588.588 0 0 1 0 11.176v-.023l5.64-4.835L8.19 8.127a.588.588 0 0 0 .68 0l2.55-1.809 2.69 2.307zm2.949-.645a4.452 4.452 0 0 0-1.757.118l-2.895-2.482 4.652-3.3V7.98zM0 9.603V2.315l4.652 3.301L0 9.603zM17.059.873l-8.53 6.053L0 .873V.588C0 .263.263 0 .588 0h15.883c.324 0 .588.263.588.588v.285zm-2.941 12.413l.552-.553a.295.295 0 0 1 .418.002l.412.412a.295.295 0 0 1 0 .42l-1.555 1.555a.588.588 0 0 1-.832 0l-1.555-1.556a.298.298 0 0 1 0-.419l.413-.412a.294.294 0 0 1 .417-.002l.553.553v-.933a3.53 3.53 0 1 1 3.53 3.53h-.293a.298.298 0 0 1-.296-.298v-.582c0-.167.131-.297.293-.297h.296a2.353 2.353 0 1 0-2.353-2.353v.933z'
      />
      <path d='M-2-4h24v24H-2z' />
    </g>
  </svg>
);

export const SomethingWentWrong = (
  <svg xmlns='http://www.w3.org/2000/svg' width='150' height='35' viewBox='0 0 150 35'>
    <path
      fill='#FFF'
      fillRule='nonzero'
      d='M0 2V0h20v2H0zm27 26L20 3h2l7 25h-2zm1 7v-2h20v2H28zm28 0c-1.774-2.087-3.163-4.529-5-8-.433-2.123-1-5.02-1-8 0-2.658.424-5.189 1-8 1.264-2.417 2.796-5.214 5-8h2c-1.333 2.309-2.215 3.957-3 5-.317 1.477-.846 3.075-1 5-.705 1.815-.942 3.902-1 6 .058 5.339 1.705 10.672 5 16h-2zM72 3c2.182 2.295 4.036 5.148 6 8l-2 2c-1.636-2.066-2.51-3.541-3-5-1-.934-1.982-2.377-3-3l2-2zm13 2l3 1c-1.087 5.577-2.965 10.688-6 15-2.731 4.48-6.982 7.887-13 10l-1-2c5.107-2.328 9.094-5.463 12-9 2.498-4.402 4.277-9.173 5-15zM63 5c1.69 2.616 3.329 5.805 5 9l-2 2c-.995-1.863-1.752-3.44-2-5-1.234-1.45-2.117-3.026-3-4l2-2zm33 30h-2c3.295-5.328 4.942-10.661 5-16-.058-2.087-.295-4.157-1-6-.143-1.875-.667-3.473-1-5-.769-1.004-1.656-2.67-3-5h2c2.204 2.786 3.736 5.583 5 8 .576 2.811 1 5.342 1 8 0 2.98-.57 5.877-1 8-1.851 3.471-3.237 5.913-5 8zm7 0v-2h20v2h-20zm19-7l7-25h2l-7 25h-2zm8-26V0h20v2h-20z'
    />
  </svg>
);

export const RaceLogo = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='136' height='29' viewBox='0 0 136 29'>
    <defs>
      <path id='a' d='M.783 28h34.97V.05H.784z' />
      <path id='c' d='M.78 28h36.463V.05H.78V28z' />
      <path id='e' d='M.075 28h34.638V.05H.075z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#FFF'
        d='M36.06 16.03l1.453-8.02L32.023 1H7.73l5.52 7.125H28.8s-1.808 6.379-1.88 6.648c-.152.576-.51 1.025-1.157 1.025H11.37l1.453-6.986-8.425 3.827L.002 28.403h7.728l1.657-4.385h7.504l4.09 4.385h8.69l-3.776-4.456L36.06 16.03z'
      />
      <g transform='translate(34 .95)'>
        <mask id='race-logo:b' fill='#fff'>
          <use xlinkHref='#a' />
        </mask>
        <path
          fill='#FFF'
          d='M30.044.05H.783l4.969 7.124h21.767s-2.752 11.044-3.002 11.99c-.218.824-1.038 1.163-1.774 1.163H8.53l1.149-8.22h12.038L18.954 8.27H14.54l-4.968 3.836h.047l-8.1 5.607-.736 3.836L6.303 28h18.314c3.548 0 6.187-4.782 6.848-7.157.659-2.374 4.289-15.672 4.289-15.672L30.044.05z'
          mask='url(#b)'
        />
      </g>
      <g transform='translate(66 .95)'>
        <mask id='race-logo:d' fill='#fff'>
          <use xlinkHref='#c' />
        </mask>
        <path
          fill='#FFF'
          d='M9.086 20.327S11.882 9.42 12.12 8.768c.239-.65.668-1.594 2.01-1.594h13.727l-1.23 7.823 8.35-5.337 1.015-4.075L30.564.05H12.627c-2.445 0-6.21 1.924-6.924 4.47C4.987 7.063.78 22.05.78 22.05l5.155 5.95h31.308l-5.784-7.674H9.086z'
          mask='url(#d)'
        />
      </g>
      <g transform='translate(100 .95)'>
        <mask id='race-logo:f' fill='#fff'>
          <use xlinkHref='#e' />
        </mask>
        <path
          fill='#FFF'
          d='M7.66 20.327S10.4 9.32 10.579 8.667c.179-.65.614-1.493 1.846-1.493h14.559l-1.288 7.65h-12.47l2.69 3.835h5.039l4.969-3.836L33.658 9.6l1.055-3.912L28.828.05H11.796c-3.518 0-6.9 2.043-7.556 4.588C3.584 7.182.075 20.334.075 20.334L5.45 28h29.262l-5.826-7.673H7.66z'
          mask='url(#f)'
        />
      </g>
    </g>
  </svg>
);

export const AddImgIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path
        id='add-img:a'
        d='M3 3V0h2v3h3v2H5v3H3V5H0V3h3zm3 6V6h3V3h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2 1.77 0 3.2-1.43 3.2-3.2 0-1.77-1.43-3.2-3.2-3.2-1.77 0-3.2 1.43-3.2 3.2z'
      />
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(0 1)'>
      <mask id='add-img:b' fill='#fff'>
        <use xlinkHref='#add-img:a' />
      </mask>
      <g fill='#fff' mask='url(#add-img:b)'>
        <path d='M0-1h24v24H0z' />
      </g>
    </g>
  </svg>
);

export const IconArrowRightGrey = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path id='icon-arrow-grey:a' d='M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6z' />
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(8 6)'>
      <mask id='icon-arrow-grey:b' fill='#fff'>
        <use xlinkHref='#icon-arrow-grey:a' />
      </mask>
      <g fill='#80868B' mask='url(#icon-arrow-grey:b)'>
        <path d='M-8-6h24v24H-8z' />
      </g>
    </g>
  </svg>
);

export const DownloadIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='17' viewBox='0 0 14 17'>
    <g fill='none' fillRule='evenodd'>
      <path fill='#FBC400' fillRule='nonzero' d='M14 6h-4V0H4v6H0l7 7 7-7zM0 15v2h14v-2H0z' />
      <path d='M-5-3h24v24H-5z' />
    </g>
  </svg>
);

export const SquareCloseIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path id='square-close:a' d='M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(5 5)'>
        <mask id='square-close:b' fill='#fff'>
          <use xlinkHref='#square-close:a' />
        </mask>
        <g fill='#FBC400' mask='url(#square-close:b)'>
          <path d='M-5-5h24v24H-5z' />
        </g>
      </g>
      <path stroke='#FBC400' d='M.5.5h23v23H.5z' />
    </g>
  </svg>
);

export const TickIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path
        id='tick:a'
        d='M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z'
      />
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(2 2)'>
      <mask id='tick:b' fill='#fff'>
        <use xlinkHref='#tick:a' />
      </mask>
      <g fill='#43A047' mask='url(#tick:b)'>
        <path d='M-2-2h24v24H-2z' />
      </g>
    </g>
  </svg>
);

export const PersonIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <path
        id='person-icon:a'
        d='M8 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
      />
    </defs>
    <use fill='#000' fillOpacity='.2' fillRule='nonzero' transform='translate(4 4)' xlinkHref='#person-icon:a' />
  </svg>
);

export const PlusIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
    <path
      fill='#767E85'
      d='M17.417 9c0-.426-.341-.768-.767-.768H9.768V1.35c0-.426-.342-.767-.768-.767s-.768.341-.768.767v6.882h-6.88c-.427 0-.768.34-.768.767 0 .209.084.406.22.543.137.136.33.225.543.22l6.882.001v6.882c0 .209.085.406.221.542.141.141.33.225.543.221.426 0 .768-.341.768-.767l.007-6.874h6.882c.426 0 .767-.34.767-.767z'
    />
  </svg>
);

export const EditPencilGrey = (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='18' height='18' viewBox='0 0 18 18'>
    <defs>
      <path
        id='pencil:prefix__a'
        d='M0 11.438v2.812h2.813l8.294-8.295-2.812-2.813L0 11.438zM13.283 3.78c.292-.292.292-.765 0-1.057L11.527.968c-.293-.293-.766-.293-1.058 0L9.097 2.34l2.813 2.813 1.373-1.373z'
      />
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(2.25 1.5)'>
      <mask id='pencil:prefix__b' fill='#fff'>
        <use xlinkHref='#pencil:prefix__a' />
      </mask>
      <g fill='#000' fillOpacity='.2' mask='url(#pencil:prefix__b)'>
        <path d='M0 0H18V18H0z' transform='translate(-2.25 -1.5)' />
      </g>
    </g>
  </svg>
);

export const GoIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0L24 0 24 24 0 24z' />
      <path fill='#767E85' fillRule='nonzero' d='M20 11L7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13z' />
    </g>
  </svg>
);

export const TrashRedIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='18' viewBox='0 0 14 18'>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0L24 0 24 24 0 24z' transform='translate(-5 -3)' />
      <path
        fill='#FF6464'
        fillRule='nonzero'
        d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z'
        transform='translate(-5 -3)'
      />
    </g>
  </svg>
);

export const SegmentsExpandIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fill-rule='evenodd'>
      <path d='M0 0H24V24H0z' />
      <path
        fill='#000'
        fill-opacity='.2'
        fill-rule='nonzero'
        d='M21 11L21 3 13 3 16.29 6.29 6.29 16.29 3 13 3 21 11 21 7.71 17.71 17.71 7.71z'
      />
    </g>
  </svg>
);

export const ExportBibIcon = (
  <svg
    width='23px'
    height='24px'
    viewBox='0 0 23 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/BIB/white'>
        <circle id='Oval' cx='4.5' cy='17.5' r='1'></circle>
        <circle id='Oval' cx='4.5' cy='6.5' r='1'></circle>
        <circle id='Oval' cx='21.5' cy='17.5' r='1'></circle>
        <circle id='Oval' cx='21.5' cy='6.5' r='1'></circle>
        <path
          d='M0,0 L0,24 L23,24 L23,0 L0,0 Z M21.0833333,17 C21.0833333,18.1045695 20.2252124,19 19.1666667,19 L3.83333333,19 C2.77478756,19 1.91666667,18.1045695 1.91666667,17 L1.91666667,7 C1.91666667,5.8954305 2.77478756,5 3.83333333,5 L19.1666667,5 C20.2252124,5 21.0833333,5.8954305 21.0833333,7 L21.0833333,17 Z'
          id='Shape'
        ></path>
        <g id='Icons-Pop-up-Menu44_Монтажная-область-1-копия-3-Copy'>
          <circle id='Oval' cx='4.5' cy='17.5' r='1'></circle>
          <circle id='Oval' cx='4.5' cy='6.5' r='1'></circle>
          <circle id='Oval' cx='21.5' cy='17.5' r='1'></circle>
          <circle id='Oval' cx='21.5' cy='6.5' r='1'></circle>
          <path
            d='M0,0 L0,24 L23,24 L23,0 L0,0 Z M21.0833333,17 C21.0833333,18.1045695 20.2252124,19 19.1666667,19 L3.83333333,19 C2.77478756,19 1.91666667,18.1045695 1.91666667,17 L1.91666667,7 C1.91666667,5.8954305 2.77478756,5 3.83333333,5 L19.1666667,5 C20.2252124,5 21.0833333,5.8954305 21.0833333,7 L21.0833333,17 Z'
            id='Shape'
          ></path>
          <g id='Group' transform='translate(0.000000, 4.000000)' className='svg-fill' fill-rule='nonzero'>
            <path
              d='M20.7,-4.26325641e-14 C21.9702549,-4.26325641e-14 23,1.02974508 23,2.3 L23,2.3 L23,13.8 C23,15.0702549 21.9702549,16.1 20.7,16.1 L20.7,16.1 L2.3,16.1 C1.02974508,16.1 0,15.0702549 0,13.8 L0,13.8 L0,2.3 C0,1.02974508 1.02974508,-4.26325641e-14 2.3,-4.26325641e-14 L2.3,-4.26325641e-14 Z M1.725,13.8 C1.40743627,13.8 1.15,14.0574363 1.15,14.375 C1.15,14.6925637 1.40743627,14.95 1.725,14.95 C2.04256373,14.95 2.3,14.6925637 2.3,14.375 C2.3,14.0574363 2.04256373,13.8 1.725,13.8 Z M21.275,13.8 C20.9574363,13.8 20.7,14.0574363 20.7,14.375 C20.7,14.6925637 20.9574363,14.95 21.275,14.95 C21.5925637,14.95 21.85,14.6925637 21.85,14.375 C21.85,14.0574363 21.5925637,13.8 21.275,13.8 Z M5.97115385,5 C5.39423077,5 4.88141026,5.13782051 4.43269231,5.41346154 C3.98397436,5.68910256 3.63301282,6.09134615 3.37980769,6.62019231 C3.12660256,7.14903846 3,7.77564103 3,8.5 C3,9.22435897 3.12660256,9.85096154 3.37980769,10.3798077 C3.63301282,10.9086538 3.98397436,11.3108974 4.43269231,11.5865385 C4.88141026,11.8621795 5.39423077,12 5.97115385,12 C6.54166667,12 7.05128205,11.8621795 7.5,11.5865385 C7.94871795,11.3108974 8.29967949,10.9086538 8.55288462,10.3798077 C8.80608974,9.85096154 8.93269231,9.22435897 8.93269231,8.5 C8.93269231,7.77564103 8.80608974,7.14903846 8.55288462,6.62019231 C8.29967949,6.09134615 7.94871795,5.68910256 7.5,5.41346154 C7.05128205,5.13782051 6.54166667,5 5.97115385,5 Z M20.3076923,5.13461538 L15.4423077,5.13461538 L15.4423077,6.60576923 L18.0961538,6.60576923 L16.8942308,7.90384615 L16.8942308,9.10576923 L17.6923077,9.10576923 C18.3782051,9.10576923 18.7211538,9.32371795 18.7211538,9.75961538 C18.7211538,9.98397436 18.625,10.1570513 18.4326923,10.2788462 C18.2403846,10.400641 17.9807692,10.4615385 17.6538462,10.4615385 C17.3333333,10.4615385 17.0080128,10.4134615 16.6778846,10.3173077 C16.4137821,10.2403846 16.1712179,10.1367949 15.9501923,10.0065385 L15.7884615,9.90384615 L15.0961538,11.3365385 C15.4358974,11.5480769 15.838141,11.7115385 16.3028846,11.8269231 C16.7676282,11.9423077 17.2371795,12 17.7115385,12 C18.3589744,12 18.9022436,11.8958333 19.3413462,11.6875 C19.7804487,11.4791667 20.1073718,11.2051282 20.3221154,10.8653846 C20.536859,10.525641 20.6442308,10.1570513 20.6442308,9.75961538 C20.6442308,9.2724359 20.4951923,8.85737179 20.1971154,8.51442308 C19.9362981,8.21434295 19.5760968,8.0013772 19.1165114,7.87552584 L18.9134615,7.82692308 L20.3076923,6.32692308 L20.3076923,5.13461538 Z M12.0096154,5 C11.3621795,5 10.8012821,5.125 10.3269231,5.375 C9.92032967,5.58928571 9.59144427,5.87186028 9.34026688,6.2227237 L9.22115385,6.40384615 L10.6346154,7.19230769 C10.7692308,6.98076923 10.9407051,6.81891026 11.1490385,6.70673077 C11.3573718,6.59455128 11.5865385,6.53846154 11.8365385,6.53846154 C12.1185897,6.53846154 12.3333333,6.59935897 12.4807692,6.72115385 C12.6282051,6.84294872 12.7019231,7.01282051 12.7019231,7.23076923 C12.7019231,7.3974359 12.6602564,7.5625 12.5769231,7.72596154 C12.5102564,7.85673077 12.3923077,8.00903846 12.2230769,8.18288462 L12.0865385,8.31730769 L9.56730769,10.6730769 L9.56730769,11.8653846 L14.8076923,11.8653846 L14.8076923,10.3557692 L12.2115385,10.3557692 L13.4807692,9.18269231 C13.9294872,8.7724359 14.2323718,8.40544872 14.3894231,8.08173077 C14.5464744,7.75801282 14.625,7.41346154 14.625,7.04807692 C14.625,6.63782051 14.5144231,6.27724359 14.2932692,5.96634615 C14.0721154,5.65544872 13.7644231,5.41666667 13.3701923,5.25 C12.9759615,5.08333333 12.5224359,5 12.0096154,5 Z M5.97115385,6.55769231 C6.29166667,6.55769231 6.54647436,6.71314103 6.73557692,7.02403846 C6.92467949,7.3349359 7.01923077,7.82692308 7.01923077,8.5 C7.01923077,9.17307692 6.92467949,9.6650641 6.73557692,9.97596154 C6.54647436,10.286859 6.29166667,10.4423077 5.97115385,10.4423077 C5.64423077,10.4423077 5.38621795,10.286859 5.19711538,9.97596154 C5.00801282,9.6650641 4.91346154,9.17307692 4.91346154,8.5 C4.91346154,7.82692308 5.00801282,7.3349359 5.19711538,7.02403846 C5.38621795,6.71314103 5.64423077,6.55769231 5.97115385,6.55769231 Z M1.725,1.15 C1.40743627,1.15 1.15,1.40743627 1.15,1.725 C1.15,2.04256373 1.40743627,2.3 1.725,2.3 C2.04256373,2.3 2.3,2.04256373 2.3,1.725 C2.3,1.40743627 2.04256373,1.15 1.725,1.15 Z M21.275,1.15 C20.9574363,1.15 20.7,1.40743627 20.7,1.725 C20.7,2.04256373 20.9574363,2.3 21.275,2.3 C21.5925637,2.3 21.85,2.04256373 21.85,1.725 C21.85,1.40743627 21.5925637,1.15 21.275,1.15 Z'
              id='Combined-Shape'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const ExportFinisherDiploma = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/finishers-diploma/white'>
        <g id='Icons-Pop-up-Menu-_Монтажная-область-1-копия' transform='translate(4.000000, 0.000000)'>
          <path
            d='M10.625,17.3217391 L10.625,23.6869565 L8.5,21.6 L6.375,23.6869565 L6.375,17.3217391 C7.6613144,18.1658074 9.3386856,18.1658074 10.625,17.3217391 Z M14.875,0.208695652 C16.0486051,0.208695652 17,1.14305791 17,2.29565217 L17,2.29565217 L17,18.9913043 C17,20.1438986 16.0486051,21.0782609 14.875,21.0782609 L14.875,21.0782609 L11.6875,21.0782609 L11.6875,16.173913 C12.0345905,15.6066609 12.2182153,14.9574464 12.21875,14.2956522 C12.21875,12.2786122 10.5538089,10.6434783 8.5,10.6434783 C6.44619112,10.6434783 4.78125004,12.2786122 4.78125,14.2956522 C4.78178475,14.9574464 4.96540952,15.6066609 5.3125,16.173913 L5.3125,16.173913 L5.3125,21.0782609 L2.125,21.0782609 C0.951394907,21.0782609 0,20.1438986 0,18.9913043 L0,18.9913043 L0,2.29565217 C0,1.14305791 0.951394907,0.208695652 2.125,0.208695652 L2.125,0.208695652 Z M8.5,11.6869565 C9.96700637,11.6869565 11.15625,12.8549093 11.15625,14.2956522 C11.1465737,14.6528397 11.0747021,15.0057638 10.94375,15.3391304 L10.625,15.8608696 C10.505294,16.0832378 10.3201718,16.2650457 10.09375,16.3826087 C9.14930556,17.0782609 7.85069444,17.0782609 6.90625,16.3826087 C6.69375,16.2782609 6.5875,16.0695652 6.375,15.8608696 L6.05625,15.3391304 C5.92529786,15.0057638 5.85342633,14.6528397 5.84375,14.2956522 C5.84375,12.8549093 7.03299363,11.6869565 8.5,11.6869565 Z M11.6875,6.46956522 L5.3125,6.46956522 L5.3125,7.51304348 L11.6875,7.51304348 L11.6875,6.46956522 Z M13.8125,3.33913043 L3.1875,3.33913043 L3.1875,4.3826087 L13.8125,4.3826087 L13.8125,3.33913043 Z'
            id='Combined-Shape'
            className='svg-fill'
            fill-rule='nonzero'
          ></path>
          <g id='Group'></g>
        </g>
      </g>
    </g>
  </svg>
);

export const DownloadReceiptIcon = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/receipt/grey'>
        <g id='Icons-Pop-up-Menu-_Монтажная-область-1-копия-2'>
          <path
            d='M19.94,1.66 L18.4,3.2 L16.2,1 L14,3.2 L11.8,1 L9.6,3.2 L7.51,1 L5.2,3.2 L3.66,1.66 L3,1 L3,23 L5.2,20.8 L7.4,23 L9.6,20.8 L11.8,23 L14,20.8 L16.09,23 L18.4,20.8 L20.6,23 L20.6,1 L19.94,1.66 Z M11.8,17.5 L6.3,17.5 L6.3,16.4 L11.8,16.4 L11.8,17.5 Z M11.8,14.2 L6.3,14.2 L6.3,13.1 L11.8,13.1 L11.8,14.2 Z M11.8,10.9 L6.3,10.9 L6.3,9.8 L11.8,9.8 L11.8,10.9 Z M15.616,10 L15.616,10.888 L15.83875,10.9065 C16.06025,10.9315 16.278,10.976 16.492,11.04 C16.7773333,11.1253333 17.0266667,11.2373333 17.24,11.376 L17.24,11.376 L16.912,12.184 L16.7071111,12.0742222 C16.3619259,11.9038519 15.9982222,11.7964444 15.616,11.752 L15.616,11.752 L15.616,13.368 L15.83856,13.42336 C16.1248533,13.4984533 16.3693333,13.5786667 16.572,13.664 C16.8253333,13.7706667 17.0386667,13.9293333 17.212,14.14 C17.3853333,14.3506667 17.472,14.6293333 17.472,14.976 C17.472,15.408 17.3133333,15.7746667 16.996,16.076 C16.6786667,16.3773333 16.2186667,16.56 15.616,16.624 L15.616,16.624 L15.616,17.52 L14.96,17.52 L14.96,16.632 L14.668,16.6035 C14.38,16.5665 14.104,16.504 13.84,16.416 C13.488,16.2986667 13.208,16.1493333 13,15.968 L13,15.968 L13.36,15.16 L13.516,15.27525 C13.68,15.38575 13.868,15.482 14.08,15.564 C14.3626667,15.6733333 14.656,15.7413333 14.96,15.768 L14.96,15.768 L14.96,14.168 L14.74032,14.11248 C14.45744,14.03696 14.2146667,13.9554667 14.012,13.868 C13.7586667,13.7586667 13.5466667,13.5986667 13.376,13.388 C13.2053333,13.1773333 13.12,12.8986667 13.12,12.552 C13.12,12.12 13.2773333,11.752 13.592,11.448 C13.9066667,11.144 14.3626667,10.9626667 14.96,10.904 L14.96,10.904 L14.96,10 L15.616,10 Z M15.616,14.336 L15.616,15.752 C15.8986667,15.7093333 16.108,15.6266667 16.244,15.504 C16.38,15.3813333 16.448,15.2293333 16.448,15.048 C16.448,14.8666667 16.376,14.7213333 16.232,14.612 C16.088,14.5026667 15.8826667,14.4106667 15.616,14.336 L15.616,14.336 Z M14.96,11.776 L14.80512,11.80672 C14.6097067,11.8545067 14.4586667,11.9296 14.352,12.032 C14.2186667,12.16 14.152,12.3173333 14.152,12.504 C14.152,12.68 14.2213333,12.8213333 14.36,12.928 C14.4986667,13.0346667 14.6986667,13.1253333 14.96,13.2 L14.96,13.2 L14.96,11.776 Z M17.3,6.5 L17.3,7.6 L6.3,7.6 L6.3,6.5 L17.3,6.5 Z'
            id='Shape'
            className='svg-fill'
            fill-rule='nonzero'
          ></path>
          <rect id='Rectangle' x='0' y='0' width='24' height='24'></rect>
        </g>
      </g>
    </g>
  </svg>
);

export const RegistrationDetailsIcon = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/reg_detail/grey'>
        <g id='Icons-Pop-up-Menu-_Монтажная-область-1'>
          <g id='Group'>
            <rect id='Rectangle' x='0' y='0' width='24' height='24'></rect>
            <path
              d='M12.4,6.96 C9.7490332,6.96 7.6,9.1090332 7.6,11.76 C7.6,14.4109668 9.7490332,16.56 12.4,16.56 C15.0509668,16.56 17.2,14.4109668 17.2,11.76 C17.2,10.4869608 16.6942872,9.26606207 15.7941125,8.36588745 C14.8939379,7.46571283 13.6730392,6.96 12.4,6.96 Z M15.4,14.76 L9.4,14.76 L9.4,13.56 L15.4,13.56 L15.4,14.76 Z M15.4,12.24 L9.4,12.24 L9.4,11.04 L15.4,11.04 L15.4,12.24 Z M15.4,9.84 L9.4,9.84 L9.4,8.64 L15.4,8.64 L15.4,9.84 Z'
              id='Shape'
              className='svg-fill'
              fill-rule='nonzero'
            ></path>
            <path
              d='M19.24,0.6 L5.56,0.6 C5.01082647,0.661388748 4.59657952,1.12741658 4.59997897,1.68 L4.59997897,22.44 C4.65372583,22.9462742 5.05372583,23.3462742 5.56,23.4 L19.24,23.4 C19.7462742,23.3462742 20.1462742,22.9462742 20.200021,22.44 L20.200021,1.68 C20.2034205,1.12741658 19.7891735,0.661388748 19.24,0.6 L19.24,0.6 Z M17.92,18.12 L16.12,16.32 L16.12,16.32 C15.0910926,17.2277538 13.7719332,17.7383962 12.4,17.76 C9.0862915,17.76 6.4,15.0737085 6.4,11.76 C6.4,8.4462915 9.0862915,5.76 12.4,5.76 C15.7137085,5.76 18.4,8.4462915 18.4,11.76 C18.4224466,13.1185177 17.9537192,14.4394767 17.08,15.48 L17.08,15.48 L18.88,17.28 L17.92,18.12 Z'
              id='Shape'
              className='svg-fill'
              fill-rule='nonzero'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const TransferRegistrationIcon = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/transfer-reg/grey'>
        <circle id='Oval' className='svg-fill' fill-rule='nonzero' cx='11.8461538' cy='7.36923077' r='2.36923077'></circle>
        <path
          d='M12,11 C14.7614237,11 17,13.2385763 17,16 L17,18 L17,18 L7,18 L7,16 C7,13.2385763 9.23857625,11 12,11 Z'
          id='Rectangle'
          className='svg-fill'
        ></path>
        <path
          d='M3.8385414,10 L3.838,11 L7.94440139,10.9996194 C6.68979018,11.9077391 5.85037644,13.3541845 5.76500159,15.0001143 L3.838,15 L3.8385414,16 L-4.13633572e-11,13.0225338 L3.8385414,10 Z'
          id='Combined-Shape'
          className='svg-fill'
          fill-rule='nonzero'
        ></path>
        <path
          d='M19.8385414,10 L19.838,11 L23.9444014,10.9996194 C22.6897902,11.9077391 21.8503764,13.3541845 21.7650016,15.0001143 L19.838,15 L19.8385414,16 L16,13.0225338 L19.8385414,10 Z'
          id='Combined-Shape-Copy-2'
          className='svg-fill'
          fill-rule='nonzero'
          transform='translate(20.000000, 13.000000) scale(-1, 1) translate(-20.000000, -13.000000) '
        ></path>
      </g>
    </g>
  </svg>
);

export const GoToRaceIcon = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/go_to_race/grey'>
        <g id='go_to_race_icon-5-—-копия'>
          <g id='Group' transform='translate(2.000000, 4.000000)' className='svg-fill' fill-rule='nonzero'>
            <path
              d='M18.1,0 C19.2,0 20,0.8 20,1.9 L20,1.9 L20,14.1 C20,15.2 19.2,16 18.1,16 L18.1,16 L1.9,16 C0.9,16 0,15.1 0,14.1 L0,14.1 L0,2 C0,0.9 0.9,0 2,0 L2,0 Z M18,3 L2,3 L2,14 L18,14 L18,3 Z M10.1,6 L14.5,8.5 L10.1,11 L10.1,9.8 L5.5,9.8 L5.5,7.3 L10.1,7.3 L10.1,6 Z'
              id='Combined-Shape'
            ></path>
          </g>
          <rect id='Rectangle' x='0' y='0' width='24' height='24'></rect>
        </g>
      </g>
    </g>
  </svg>
);

export const MoreThreeDots = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='icn/more'>
        <g id='more_vert-24px'>
          <polygon id='Path' points='0 0 24 0 24 24 0 24'></polygon>
          <path
            d='M12,8 C13.1,8 14,7.1 14,6 C14,4.9 13.1,4 12,4 C10.9,4 10,4.9 10,6 C10,7.1 10.9,8 12,8 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z M12,16 C10.9,16 10,16.9 10,18 C10,19.1 10.9,20 12,20 C13.1,20 14,19.1 14,18 C14,16.9 13.1,16 12,16 Z'
            id='Shape'
            fill-opacity='0.196104677'
            fill='#000000'
            fill-rule='nonzero'
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ArrowUp = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Results' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Up-to-top-button' transform='translate(-1349.000000, -1135.000000)'>
        <g id='up-to-top' transform='translate(1337.000000, 1123.000000)'>
          <g id='arrow_upward-24px' transform='translate(12.000000, 12.000000)'>
            <polygon id='Path' points='0 0 24 0 24 24 0 24'></polygon>
            <polygon
              id='Path'
              fill='#262E35'
              fill-rule='nonzero'
              points='4 12 5.41 13.41 11 7.83 11 20 13 20 13 7.83 18.58 13.42 20 12 12 4'
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const InfoIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='#000000'>
    <path d='M0 0h24v24H0V0z' fill='none' />
    <path d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
  </svg>
);

export const PhotoIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='#000000'>
    <path d='M0 0h24v24H0z' fill='none' />
    <path d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' />
  </svg>
);
